@if ((detection$ | async); as detection) {
  <div
    class="container">
    <div style="display: flex;flex-direction: row">
      @if (detection.status != detectionStatusEnum.TO_BE_CONFIRMED) {
        <div [style.background-color]="detection.textColor"
          matTooltip="{{ detection | status}}"
        style="width: 5px; height: 31px;"></div>
      }
      <div style="padding-left: 10px;">
        <div>{{detection.name}}</div>
        <div style="font-size: smaller">{{detection.createMode | formatDetectionMode}} ({{detection | confidence | number:'1.0-0'}} %)</div>
      </div>
    </div>
    <div class="icons">
      @if (!detection.show) {
        <mat-icon>visibility_off</mat-icon>
      }
      <mat-icon>share</mat-icon>
    </div>
  </div>
}



